import { Button, Typography } from "@mui/material";
import { GetApp as GetAppIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export function DropzoneHeader(props: { label: string; template?: string }) {
  const { t } = useTranslation();

  return render();

  function render() {
    return (
      <Styles>
        <Typography variant="h3" className="label">
          {props.label}
        </Typography>

        {props.template && (
          <Button
            size="small"
            startIcon={<GetAppIcon />}
            variant="text"
            color="primary"
            component="a"
            download
            href={props.template}
          >
            {t("label.template")}
          </Button>
        )}
      </Styles>
    );
  }
}

const Styles = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(1, 0)};
`;
